import React from 'react';
import { PROCESS } from '../data/mock';

export default function Process() {
  return (
    <section id="processo" className="py-24 md:py-36 relative">
      <div className="thesis-container">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end border-b border-white/8 pb-8 md:pb-12">
          <div className="md:col-span-2">
            <span className="font-mono-label text-[#8E8B85]">(05) — Processo</span>
          </div>
          <div className="md:col-span-7 reveal">
            <h2 className="font-display-tight text-[44px] md:text-[80px] leading-[0.92] text-[#F5F1E8]">
              Como <span className="font-serif-italic kinetic-grad">trabalhamos</span> juntos
            </h2>
          </div>
          <div className="md:col-span-3 md:text-right reveal">
            <p className="text-[15px] text-[#8E8B85] leading-relaxed max-w-[300px] md:ml-auto">
              Um processo simples e transparente. Sem reunião de uma hora pra resolver o que dava em 10 minutos.
            </p>
          </div>
        </div>

        {/* Steps timeline */}
        <div className="mt-12 md:mt-20 relative">
          {/* Vertical line on left for mobile, horizontal middle for desktop */}
          <div className="hidden md:block absolute left-0 right-0 top-[50%] h-px bg-gradient-to-r from-transparent via-[#C8FF61]/30 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-5 gap-0 relative">
            {PROCESS.map((p, i) => (
              <div key={p.n}
                className={`reveal relative py-8 md:py-12 px-2 md:px-6 group cursor-hover ${
                  i < PROCESS.length - 1 ? 'md:border-r border-b md:border-b-0 border-white/8' : 'border-b md:border-b-0'
                }`}
              >
                {/* Dot on line */}
                <span className="hidden md:block absolute left-1/2 top-[50%] -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-[#0A0B0E] border-2 border-[#C8FF61] z-10 group-hover:bg-[#C8FF61] transition-colors duration-300" />

                <span className="font-display-tight text-[80px] md:text-[100px] leading-none text-[#F5F1E8]/15 group-hover:text-[#C8FF61] transition-colors duration-700">
                  {p.n}
                </span>
                <h3 className="mt-4 font-display-tight text-[22px] md:text-[24px] leading-tight text-[#F5F1E8]">
                  {p.title}
                </h3>
                <p className="mt-3 text-[14px] leading-relaxed text-[#8E8B85]">
                  {p.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Guarantee block */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-12 gap-6 reveal">
          <div className="md:col-span-7 relative overflow-hidden rounded-[8px] aspect-[16/9] glass">
            <img
              src="https://assets.emergent.sh/assets/showcase/Laptop2.webp"
              alt="Em produção"
              className="absolute inset-0 w-full h-full object-cover opacity-70 hover:opacity-90 hover:scale-[1.02] transition-all duration-[1500ms]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B0E]/95 via-[#0A0B0E]/40 to-transparent" />
            <div className="absolute bottom-8 left-8 right-8 z-10 text-[#F5F1E8]">
              <span className="font-mono-label text-[#C8FF61]">// EM PRODUÇÃO</span>
              <p className="font-serif-italic text-[28px] md:text-[44px] leading-[1.05] mt-2 max-w-[640px]">
                Cada peça passa pelo mesmo cuidado de uma marca grande.
              </p>
            </div>
          </div>

          <div className="md:col-span-5 glass-strong rounded-[8px] p-9 md:p-11 flex flex-col justify-between text-[#F5F1E8] relative overflow-hidden">
            <div className="absolute -top-20 -right-20 w-[280px] h-[280px] rounded-full bg-[#C8FF61]/10 blur-3xl pointer-events-none" />
            <div className="relative">
              <span className="font-mono-label text-[#C8FF61]">// GARANTIA</span>
              <h3 className="font-display-tight text-[34px] md:text-[44px] leading-[1] mt-4">
                1 rodada de ajustes <span className="font-serif-italic kinetic-grad">grátis</span> por lote.
              </h3>
            </div>
            <p className="text-[14px] text-[#F5F1E8]/65 mt-6 leading-relaxed relative">
              Sem fidelidade. Sem letra miúda. Você aprova antes de qualquer entrega.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
